import { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { ERRORS, URL_VALIDATOR } from '../../../constants/AppConstants';
import getCroppedImage from '../../../Util/getCroppedImage';
import IconCropper from '../../../components/IconCropper/iconCropper';
import { createWebsite } from '../../../services/websitesService';
import { useMutation } from 'react-query';
import { useAppContext } from '../../../appProvider/contextProvider';
import { toast } from 'react-toastify';


const AddWebsites = () => {
    const history = useHistory();

    const {addWebsite,
        isDirty, 
        setIsDirty,
        setPathToNavigate,
        setDiscardPromptOpen
    } = useAppContext();

    
    const iconRef = useRef(null);


    const [title, setWebsiteTitle] = useState('');
    const [url, setWebsiteUrl]  = useState('');
    const [logo, setWebsiteLogo]  = useState(null);
    const [logoName, setLogoName]= useState('');
    const [imagePath, setIconPath] = useState('');
    const [openCropper, setOpenCropper] = useState(false);
    
    const [titleError, setTitleError] = useState(null);
    const [urlError, setURLError] = useState(null);


    const handelTitleValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.WEBSITE_TITLE_REQUIRED);
        } else if(value.trim().length > 150 ) {
            setTitleError(ERRORS.WEBSITE_TITLE_MAX_LENGTH);
        }
        else {
            setTitleError(null);
        }
        setWebsiteTitle(value);
    }

    const handelUrlValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setURLError(ERRORS.WEBSITE_TITLE_REQUIRED);
        } else if(!value.toLowerCase().startsWith('https://')) {
            setURLError(ERRORS.WEBSITE_HTTPS_REQUIRED);
        } else if(!value.toLowerCase().match(URL_VALIDATOR)) {
            setURLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setURLError(null);
        }
        setWebsiteUrl(value.toLowerCase());
    }

    const handelFileUpload = (({target}) => {
        if(target.files && target.files[0]) {
            setIsDirty(true);
            const url = URL.createObjectURL(target.files[0]);
            setLogoName(target.files[0].name);
            setIconPath(url);
            setOpenCropper(true);
            iconRef.current.value = '';
        }
    });

    const onCancelCrop = () => {
        setIconPath('');
        setOpenCropper(false);
    }

    const onClearBanner = () => {
        setIconPath('');
        setWebsiteLogo(null);
    }
    
    const getCroppedIcon = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            imagePath,
            croppedAreaPixel,
            0,
            logoName,
        );
        setIconPath(url);
        setWebsiteLogo(file);
        setOpenCropper(false);
    }


    const isSaveDisabled = () => {
        return title.length <= 0 || url.length <= 0 || titleError || urlError;
    }


    const onSave = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('title', title);
        formData.append('url', url);
        if(logo) formData.append('logo', logo);
        createWeb.mutate(formData)
    }

    const createWeb = useMutation((formData) => {
        return createWebsite(formData)
    }, {
        onSuccess: ((webSiteData) => {
            if(webSiteData.error) {
                handelError(webSiteData.error);
            } else if(webSiteData.errors) {
                handelError(webSiteData.errors);
            } else {
                addWebsite(webSiteData);
            
                setIsDirty(false);
                toast.success('The website is added successfully.');
                history.push('/websites-setup');
                
            }
        //    setOpenDialogue(false);
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });

    const handelError = (error) => {
        if(error.url) {
            toast.error(error.url[0]);
        }
        if(error.logo) {
            toast.error(ERRORS[error.logo[0]]);
        }
        if(error.website) {
            toast.error(ERRORS[error.website])
        }
    }

    const onBack = () => {
        if(isDirty) {
            setDiscardPromptOpen(true);
            setPathToNavigate('/websites-setup');
        } else {
            history.goBack();
        }
    }


    return <> 
        <div className="panel full-height">
                <div className="panel-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0 ">
                            <i className="icon icon-chevron-left mr-2" onClick={onBack} ></i> Add Website
                        </h3>
                    </div>                                
                </div>
                <div className="panel-body scrollable_y">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <div className="form-group">
                            <label className="form-label text-dark medium">Website Name *</label>
                            <div className="input-addon input-group-right">
                                <i className="icon icon-edit"></i>
                                <input 
                                    type="text" 
                                    placeholder="Website Name" 
                                    className="form-control"
                                    value={title} 
                                    onChange={({target}) => handelTitleValidation(target.value)}
                                />
                            </div>
                            { titleError && <span className="error-message">{titleError}</span>}
                        </div>
                        <div className="form-group">
                            <label className="form-label text-dark medium">Website URL *</label>
                            <div className="input-addon input-group-right">
                                <i className="icon icon-website"></i>
                                <input 
                                    type="text"
                                    placeholder="Website URL"
                                    className="form-control"
                                    value={url} 
                                    onChange={({target}) => handelUrlValidation(target.value)}
                                />
                            </div>
                            { urlError && <span className="error-message">{urlError}</span>}
                        </div>
                        {/* <div className="form-group">
                            <label className="form-label text-dark medium">Agent</label>
                            <div className="input-addon input-group-right">
                                <i className="icon icon-edit"></i>
                                <input type="text" placeholder="Website URL" value="Jenny Wilson" className="form-control"/>
                            </div>
                            <span className="error-message">Optional. The email of the person who will manage the notifications for this website will receive an invitation email. If left blank, only the current account can send notifications.</span>
                        </div> */}
                        <div className="form-group">
                            <label className="form-label text-dark medium">Icon</label>
                            <div className="d-flex align-items-center">
                                <div className="file-upload">                                        
                                    <input 
                                        type="file"
                                        ref={iconRef} 
                                        className="mb-2"
                                        accept="image/*"
                                        onChange={(event) => handelFileUpload(event)}
                                    />
                                    <i className="icon icon-file"></i>                                        
                                    Select File
                                </div>
                                {logo && <span className="ml-3">{logoName}</span>}
                                {logo && <button className="btn ml-2 btn-grey" onClick={() => onClearBanner()} ><i className="icon icon-close mr-2"></i>Clear</button>}
                            </div>                                                                           
                            <span className="text-grey">Note :- The icon will appear inside the Desktop Push Notification received by your readers. 
                                &nbsp;<b>Ideally, the image is square, having a minimum size of 256x256</b>. And colorful. And recognizable...</span>
                        </div>
                        <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={onSave} >Save</button>
                    </div>
                </div>
            </div>
        </div>

        <IconCropper
            open={openCropper} 
            onClose={onCancelCrop} 
            url={imagePath} 
            onSave={getCroppedIcon} 
        />
    </> 

}

export default AddWebsites;